import { useState } from "react";
import intl from "react-intl-universal";
import { PageHeaderWithBack } from "../../../../Components/Molecules";
import { PIX_SALES_TABS } from "./constants";
import { PixSalesHistoryTable } from "./components/PixSalesHistoryTable";
import { PixSalesSummaryCards } from "./components/PixSalesSummaryCards";
import { PixChargesPanel } from "./components/PixChargesPanel";

export const PixDetalhes = () => {
  const [activeTab, setActiveTab] = useState("charges");
  const activeTabMeta = PIX_SALES_TABS.find((tab) => tab.id === activeTab) ?? PIX_SALES_TABS[0];
  const tabLabel = activeTabMeta.labelKey
    ? intl.get(activeTabMeta.labelKey)
    : activeTabMeta.label;

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title={intl.get("pix.charges.salesManagementTitle")}
        subTitle={intl.get("pix.charges.salesManagementSubtitle")}
        backTo="/pix"
      />

      <PixSalesSummaryCards />

      <div className="mb-4 flex w-full flex-col gap-2 sm:flex-row">
        {PIX_SALES_TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          const label = tab.labelKey ? intl.get(tab.labelKey) : tab.label;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-1 items-center justify-center rounded-xl border px-4 py-3 text-sm font-semibold transition ${
                isActive
                  ? "border-[#e7a73f] bg-brand-cream/60 text-brand-dark"
                  : "border-gray-200 bg-white text-gray-500 hover:border-gray-300 hover:text-brand-dark"
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>

      {activeTab === "charges" ? (
        <PixChargesPanel />
      ) : (
        <section className="mt-6">
          <h2 className="mb-3 text-sm font-bold text-brand-dark">
            {intl.get("pix.charges.historyTitle", { label: tabLabel.toLowerCase() })}
          </h2>

          <PixSalesHistoryTable
            key={activeTab}
            filterTable={activeTabMeta.filterTable}
            apiContext={activeTabMeta.apiContext}
            variant={activeTab}
          />
        </section>
      )}
    </div>
  );
};
